// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3WuXs","bigColWidth":"Table_bigColWidth__u4XLe","biggerColWidth":"Table_biggerColWidth__107Md","row":"Table_row__1-4af","col":"Table_col__23mW9"};